/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { disbandEnsemble } from '../fn/disband-ensemble-dialog/disband-ensemble';
import { DisbandEnsemble$Params } from '../fn/disband-ensemble-dialog/disband-ensemble';
import { DisbandImpactDto as FeatureEnsemblesDisbandImpactDto } from '../models/feature/ensembles/disband-impact-dto';
import { getImpact } from '../fn/disband-ensemble-dialog/get-impact';
import { GetImpact$Params } from '../fn/disband-ensemble-dialog/get-impact';

@Injectable({ providedIn: 'root' })
export class DisbandEnsembleDialogClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `disbandEnsembleDialogGetImpact()` */
  static readonly DisbandEnsembleDialogGetImpactPath = '/disband-ensemble-dialog/{ensembleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImpact()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImpact$Response(ensembleId: number, context?: HttpContext): Observable<StrictHttpResponse<FeatureEnsemblesDisbandImpactDto>> {
    const obs = getImpact(this.http, this.rootUrl, { ensembleId } satisfies GetImpact$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImpact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImpact(ensembleId: number, context?: HttpContext): Observable<FeatureEnsemblesDisbandImpactDto> {
    const resp = this.getImpact$Response(ensembleId, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureEnsemblesDisbandImpactDto>): FeatureEnsemblesDisbandImpactDto => r.body)
    );
  }

  /** Path part for operation `disbandEnsembleDialogDisbandEnsemble()` */
  static readonly DisbandEnsembleDialogDisbandEnsemblePath = '/disband-ensemble-dialog/{ensembleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disbandEnsemble()` instead.
   *
   * This method doesn't expect any request body.
   */
  disbandEnsemble$Response(ensembleId: number, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = disbandEnsemble(this.http, this.rootUrl, { ensembleId } satisfies DisbandEnsemble$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disbandEnsemble$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disbandEnsemble(ensembleId: number, context?: HttpContext): Observable<void> {
    const resp = this.disbandEnsemble$Response(ensembleId, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
